/* eslint no-console: 0 */
<template>
  <div class="product-purchase">
    <div
      v-if="hasVariants()"
      class="product-purchase__options"
    >
      <template v-if="hasOptionVariants()">
        <div class="product-option-group">
          <div class="product-option-group__header">
            <span>{{ variantOptionNameLabel() }}<template v-if="selectedVariantLabel()">: <strong>{{ selectedVariantLabel() }}</strong></template></span>
            <a
              v-if="hasSizeChart()"
              class="product-option-group__link"
              href="#size-chart"
              data-bs-toggle="modal"
              data-bs-target="#size-chart"
            >
              Таблица размеров
            </a>
          </div>

          <div class="product-option-group__values">
            <div
              v-for="variant in variantsByColor(selectedColorId)"
              :key="variant.id"
              class="product-option-value"
              :class="variant.quantity == 0 ? 'disabled' : ''"
            >
              <label :for="variant.id">
                <input
                  :id="variant.id"
                  v-model="selectedVariantId"
                  type="radio"
                  name="selected-variant"
                  :value="variant.id"
                  :disabled="variant.quantity == 0"
                >
                <span>{{ variantOptionValueName(variant) }}</span>
              </label>
            </div>
          </div>
        </div>
      </template>

      <template v-if="hasColorVariants()">
        <div class="product-option-group">
          <div class="product-option-group__header">
            <span>Цвет<template v-if="selectedColorName()">: <strong>{{ selectedColorName() }}</strong></template></span>
          </div>

          <div class="product-option-group__values">
            <div
              v-for="color in variantColors()"
              :key="color.id"
              class="product-option-value"
            >
              <label :for="color.id">
                <input
                  :id="color.id"
                  v-model="selectedColorId"
                  type="radio"
                  name="selected-color"
                  :value="color.id"
                >
                <span>{{ color.name }}</span>
              </label>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div class="product-purchase__actions">
      <template v-if="productInStock() || productSoonInStock()">
        <button
          class="product-purchase__submit"
          :class="{ 'product-purchase__submit--added': addConfirmationVisible }"
          type="button"
          :disabled="loadingState"
          @click="addToCart()"
        >
          <span
            class="product-purchase__submit-label"
            :class="{ 'is-hidden': addConfirmationVisible }"
          >
            <template v-if="productInStock()">
              Добавить в корзину
            </template>
            <template v-if="productSoonInStock()">
              Предзаказ
            </template>
          </span>

          <span
            v-if="addConfirmationVisible"
            :key="addConfirmationKey"
            class="product-purchase__submit-feedback"
            aria-live="polite"
          >
            <i
              class="uk-shell-icon ph-light ph-check"
              aria-hidden="true"
            />
            <span>Добавлено</span>
          </span>

          <div
            v-if="loadingState"
            class="btn-spinner"
          >
            <span class="uk-shell-sr-only" />
          </div>
        </button>
      </template>

      <template v-else>
        <span class="product-purchase__submit product-purchase__submit--disabled" aria-disabled="true">
          Нет в наличии
        </span>
        <p class="product-purchase__note">
          Наш менеджер расскажет вам о дате поступления этого товара.
          Для информации или предзаказа воспользуйтесь формой обратной связи
        </p>
      </template>

      <template v-if="hasError()">
        <div class="product-purchase__error">{{ error }}</div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['add-to-cart'],
  props: {
    'product': Object,
    'loadingState': Boolean,
    'error': String
  },

  data: function() {
    let firstVariant;
    if (this.product.variants !== undefined) {
      firstVariant = this.product.variants.find((e) => { return (e.quantity != 0); });
    }

    return {
      selectedVariantId: firstVariant ? firstVariant.id : null,
      selectedColorId: firstVariant ? firstVariant.color?.id : null,
      awaitingAddToCartResult: false,
      addConfirmationVisible: false,
      addConfirmationKey: 0,
      addConfirmationTimeoutId: null
    };
  },

  watch: {
    selectedColorId: function(colorId) {
      if (!this.hasColorVariants()) { return; }

      const variants = this.variantsByColor(colorId);
      const firstAvailableVariant = variants.find((variant) => { return variant.quantity != 0; });
      this.selectedVariantId = firstAvailableVariant ? firstAvailableVariant.id : (variants[0]?.id || null);
    },

    loadingState: function(isLoading, wasLoading) {
      if (isLoading || !wasLoading || !this.awaitingAddToCartResult) {
        return;
      }

      window.setTimeout(() => {
        if (!this.awaitingAddToCartResult || this.loadingState) {
          return;
        }

        const wasSuccessful = !this.error;
        this.awaitingAddToCartResult = false;

        if (wasSuccessful) {
          this.showAddConfirmation();
        }
      }, 0);
    },

    error: function(nextError) {
      if (!nextError || !this.awaitingAddToCartResult) {
        return;
      }

      this.awaitingAddToCartResult = false;
      this.hideAddConfirmation();
    }
  },

  beforeUnmount: function() {
    this.clearAddConfirmationTimeout();
  },

  methods: {
    hasSizeChart: function() { return document.getElementById('size-chart') !== null; },
    productInStock: function() { return (this.product.status == 'in_stock'); },
    productSoonInStock: function() { return (this.product.status == 'soon_in_stock'); },

    addToCart: function() {
      this.awaitingAddToCartResult = true;
      this.hideAddConfirmation();

      const params = {
        productId: this.product.id,
        variantId: this.selectedVariantId
      };
      this.$emit('add-to-cart', params);
    },

    showAddConfirmation: function() {
      this.clearAddConfirmationTimeout();
      this.addConfirmationVisible = true;
      this.addConfirmationKey += 1;
      this.addConfirmationTimeoutId = window.setTimeout(() => {
        this.addConfirmationVisible = false;
        this.addConfirmationTimeoutId = null;
      }, 1600);
    },

    hideAddConfirmation: function() {
      this.clearAddConfirmationTimeout();
      this.addConfirmationVisible = false;
    },

    clearAddConfirmationTimeout: function() {
      if (this.addConfirmationTimeoutId === null) {
        return;
      }

      window.clearTimeout(this.addConfirmationTimeoutId);
      this.addConfirmationTimeoutId = null;
    },

    variantColors: function() {
      let uniqColors = [];

      let tempC = {};
      this.product.variants.forEach(variant => {
        if (!variant.color) { return; }
        if (!tempC[variant.color.id]) {
          tempC[variant.color?.id] = true;
          uniqColors.push(variant.color);
        }
      });

      return uniqColors;
    },

    variantOptions: function() {
      return this.product.variants.filter((variant) => {
        return ((variant.option && variant.option.value !== undefined) ||
        variant.cupSize && variant.cupSize !== undefined);
      });
    },

    variantsByColor: function(colorId) {
      if (!this.hasVariants()) { return []; }
      if (!this.hasColorVariants()) { return this.product.variants; }

      return this.product.variants.filter( (variant) => {
        return variant.color?.id == colorId;
      });
    },

    hasVariants: function() {
      return this.product.variants !== undefined && this.product.variants.length > 0;
    },

    hasColorVariants: function() {
      return this.variantColors().length > 0;
    },

    hasOptionVariants: function() {
      return this.variantOptions().length > 0;
    },

    hasCupSizeVariants: function() {
      return this.product.variants.some((variant) => { return variant.cupSize; });
    },

    variantOptionValueName: function(variant) {
      const option = variant.option?.value || '';
      const cupSize = variant.cupSize || '';
      return option + cupSize;
    },

    variantOptionName: function() {
      let name = this.product.variants[0].option?.name;
      if (name !== undefined && this.hasCupSizeVariants()) {
        name = 'Размер';
      } else if (name === undefined) {
        name = this.hasCupSizeVariants() ? 'Размер чашечки' : 'Размер';
      }
      name = name && name[0].toLowerCase() + name.slice(1) || name; // lower first

      return name;
    },

    variantOptionNameLabel: function() {
      const name = this.variantOptionName();
      return name && name[0].toUpperCase() + name.slice(1);
    },

    selectedVariant: function() {
      return this.product.variants.find((variant) => { return variant.id == this.selectedVariantId; });
    },

    selectedVariantLabel: function() {
      const variant = this.selectedVariant();
      return variant ? this.variantOptionValueName(variant) : '';
    },

    selectedColorName: function() {
      const color = this.variantColors().find((item) => { return item.id == this.selectedColorId; });
      return color ? color.name : '';
    },

    hasError: function() {
      return Boolean(this.error);
    }
  },
};
</script>
